import cx from 'classnames'

import { Workspace } from 'types'
import { Button } from 'components/Button'
import { ReactComponent as SwitchSelectIcon } from 'assets/img/switch-select-16.svg'
import Avatar from 'common/Avatar/Avatar'
import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { getInitials } from 'utils'
import { useIsBlaze } from 'hooks/useIsBlaze'
import Styles from './WorkspaceSelector.module.scss'

import { useWorkspace } from 'hooks/useWorkspace'
import { ChevronDown } from 'almanac-ui/icons/12'
import { Check } from 'blaze-ui/icons/16'

export const WorkspaceSelector = ({
  workspaceId,
  workspaces,
  onWorkspaceSelect,
  isIcon = false,
}: {
  workspaceId: number
  workspaces: Workspace[]
  onWorkspaceSelect: (id: number) => void
  isIcon?: boolean
}) => {
  const workspace = useWorkspace(workspaceId)
  const isBlaze = useIsBlaze()
  if (!workspace) return null

  return (
    <DropdownTrigger placement="bottom" popoverClassName={Styles.popover}>
      <Button
        size="md"
        variant="tertiary"
        className={isIcon ? Styles.workspaceButtonMobile : Styles.workspaceButton}
        data-testid="workspaceSelectorTrigger"
        endIcon={isIcon ? ChevronDown : SwitchSelectIcon}
        endIconClassName={Styles.endIcon}
      >
        <div className={Styles.workspaceName}>
          <Avatar label={getInitials(workspace.name)} size={16} url={workspace.logo_url} workspaceId={workspace.id} />
          {!isIcon && <span className={Styles.text}>{workspace.name}</span>}
        </div>
      </Button>
      {(close) => (
        <div className={Styles.workspaceMenu}>
          {workspaces.map(({ id, name, logo_url }) => {
            return (
              <div
                key={id}
                onClick={() => {
                  onWorkspaceSelect(id)
                  close()
                }}
                className={cx(Styles.workspaceRow, {
                  [Styles.currentWorkspace]: workspaceId === id,
                  [Styles.isBlaze]: isBlaze,
                })}
              >
                <div className={Styles.workspaceName}>
                  <Avatar label={getInitials(name)} size={24} url={logo_url} workspaceId={id} />
                  <span className={Styles.text}>{name}</span>
                </div>
                {workspaceId === id && <Check />}
              </div>
            )
          })}
        </div>
      )}
    </DropdownTrigger>
  )
}
